import React from "react";
import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, Tags, Settings, LogOut, ExternalLink, ClipboardList, Headset, Users2, Shield, Wrench, FileUp, BarChart2, Brain } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const LOGO_URL = "https://www.gotparts.ca/wp-content/uploads/2024/12/logo.png";

const links = [
  { to: "/admin", end: true, label: "Dashboard", icon: LayoutDashboard },
  { to: "/admin/orders", label: "Orders & Quotes", icon: ClipboardList },
  { to: "/admin/customers", label: "Customers", icon: Users2 },
  { to: "/admin/support", label: "Support", icon: Headset },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/taxonomies", label: "Categories & Brands", icon: Tags },
  { to: "/admin/users", label: "Users & Admins", icon: Shield },
  { to: "/admin/settings", label: "Settings", icon: Settings },
  { to: "/admin/technicians", label: "Technicians", icon: Wrench },
  { to: "/admin/fsm-import", label: "FSM Import", icon: FileUp },
  { to: "/admin/stock-signals", label: "Stock Signals", icon: BarChart2 },
  { to: "/admin/ai-monitor", label: "AI Monitor", icon: Brain },
];

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex bg-surface">
      <aside className="w-60 shrink-0 bg-graphite text-white flex flex-col fixed inset-y-0 left-0">
        <Link to="/admin" className="flex items-center px-5 h-16 border-b border-white/10">
          <img src={LOGO_URL} alt="GOT PARTS" className="h-8 w-auto object-contain brightness-0 invert" />
        </Link>
        <nav className="flex-1 p-3 space-y-0.5">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end}
              data-testid={`admin-nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${isActive ? "bg-orange text-white" : "text-white/60 hover:text-white hover:bg-white/5"}`}>
              <l.icon className="w-4 h-4 shrink-0" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10">
          <Link to="/" className="flex items-center gap-2 px-3 py-2 text-sm text-white/60 hover:text-white"><ExternalLink className="w-4 h-4" /> View Storefront</Link>
          <button data-testid="admin-logout" onClick={() => { logout(); navigate("/admin/login"); }} className="w-full flex items-center gap-2 px-3 py-2 text-sm text-white/60 hover:text-white"><LogOut className="w-4 h-4" /> Logout</button>
          <div className="px-3 mt-2 text-xs text-white/30 truncate">{user?.email}</div>
        </div>
      </aside>
      <main className="flex-1 ml-60 min-w-0">
        <div className="max-w-6xl mx-auto p-6 lg:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
